import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { FlattenedHoldingsTableModule } from 'SecuritiesApp/ts/features/flattened-holdings-table/flattened-holdings-table.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { SaveAsWatchlistButtonModule } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.module';
import { HoldingsByTypeTableComponent } from './components/holdings-by-type-table/holdings-by-type-table.component';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { HelpModalWithTriggerComponent } from 'NewAngular/features/components/modals/help-modal/components/help-modal-with-trigger.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { FlattenedHoldingsTableComponent } from 'SecuritiesApp/ts/features/flattened-holdings-table/flattened-holdings-table.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { SaveAsWatchlistButton } from 'WatchlistApp/ts/features/save-as-watchlist-button/save-as-watchlist-button.component';
import { getLogger } from 'NewAngular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    HelpModalWithTriggerComponent,
    SaveAsWatchlistButton,
    PieChartComponent,
    SecurityHeaderControlComponent,
    TopBarNavComponent,
    SideMenuComponent,
    FlattenedHoldingsTableComponent,
    HoldingsByTypeTableComponent,
];
export class HoldingsOverviewModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [
            SaveAsWatchlistButton,
            HelpModalWithTriggerComponent,
            PieChartComponent,
            FlattenedHoldingsTableComponent,
        ];
    }
}
HoldingsOverviewModule.ɵfac = function HoldingsOverviewModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverviewModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
HoldingsOverviewModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsOverviewModule });
HoldingsOverviewModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        ConfirmModalModule,
        FlattenedHoldingsTableModule,
        HelpModalModule,
        ModuleUpsellModule,
        NavigationModule,
        PieChartModule,
        SideMenuModule,
        SaveAsWatchlistButtonModule,
        SecurityHeaderControlModule,
        SingleSelectDropdownModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
